<!-- updated -->
<template>
  <div class="restaurante-sabores">
    <div class="back-ribbon" @click="$router.go(-1)">
      <v-icon small>mdi-arrow-left</v-icon>
      <span>Volver</span>
    </div>
    <v-app-bar app flat class="restaurante-header">
      <v-toolbar-title class="brand">
        <span>Restaurante</span>
        <strong>Sabores</strong>
      </v-toolbar-title>
      <v-spacer />
      <v-btn text @click="scrollToMenu">Ver Menú</v-btn>
      <v-btn color="secondary" dark class="ml-4" @click="abrirPedido">
        <v-icon left>mdi-cart</v-icon>
        Mi pedido
        <v-badge v-if="pedido.length" :content="pedido.length" color="pink" overlap>
          <template #badge>
            <v-icon small>mdi-cart</v-icon>
          </template>
        </v-badge>
      </v-btn>
    </v-app-bar>

    <section class="hero-restaurante">
      <div class="hero-overlay">
        <v-container fill-height>
          <v-row align="center" justify="center" class="text-center hero-content">
            <v-col cols="12" md="8">
              <div class="eyebrow">Cocina Peruana con fusión internacional</div>
              <h1>Sabores auténticos, experiencia inolvidable</h1>
              <p class="hero-description">
                Disfruta de platos tradicionales peruanos y propuestas gourmet con
                ingredientes locales.
              </p>
              <div class="hero-actions">
                <v-btn large color="secondary" dark @click="scrollToMenu"
                  >Explorar Menú</v-btn
                >
                <v-btn large outlined color="white" class="ml-3" @click="abrirPedido"
                  >Ver Pedido</v-btn
                >
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </section>

    <section id="menu" class="menu-section">
      <v-container>
        <div class="section-header">
          <div>
            <span class="section-label">Menú</span>
            <h2>Descubre nuestras especialidades</h2>
          </div>
          <p>
            Platos preparados con ingredientes frescos y recetas inspiradas en la
            tradición peruana.
          </p>
        </div>

        <v-tabs v-model="activeTab" background-color="transparent" centered>
          <v-tab v-for="category in menuCategories" :key="category.key">
            {{ category.label }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="activeTab" class="mt-6">
          <v-tab-item v-for="category in menuCategories" :key="category.key">
            <v-row>
              <v-col v-for="item in menu[category.key]" :key="item.name" cols="12" md="4">
                <v-card class="menu-card" elevation="8">
                  <v-img :src="item.img" height="240px" class="menu-image" />
                  <v-card-text>
                    <div class="menu-card-title">{{ item.name }}</div>
                    <p class="menu-card-description">{{ item.description }}</p>
                    <div class="menu-card-footer">
                      <span class="price">S/ {{ item.price }}</span>
                      <v-btn small color="secondary" dark @click="agregarPedido(item)">
                        Agregar
                      </v-btn>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-container>
    </section>

    <v-dialog v-model="dialogPedido" max-width="620">
      <v-card class="order-dialog">
        <div class="order-dialog-accent" />
        <v-card-title class="headline order-dialog-title">
          <div class="order-dialog-text">
            <div class="order-dialog-label">Mi Pedido</div>
            <div class="order-dialog-subtitle">
              Revisa tu selección y confirma tu orden antes de enviar.
            </div>
          </div>
          <v-chip color="secondary" dark small v-if="pedido.length">
            {{ pedido.length }} item<span v-if="pedido.length > 1">s</span>
          </v-chip>
        </v-card-title>
        <v-divider />
        <v-card-text class="order-card-body">
          <div v-if="pedido.length" class="order-list">
            <div v-for="(item, idx) in pedido" :key="idx" class="order-card">
              <div>
                <div class="order-item-name">{{ item.name }}</div>
                <div class="order-item-description">S/ {{ item.price }}</div>
              </div>
              <v-btn icon small class="order-delete-btn" @click="eliminarPedido(idx)">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
          <div v-else class="empty-order-card">
            <v-avatar class="empty-order-avatar" size="56">
              <v-icon color="secondary">mdi-cart-off</v-icon>
            </v-avatar>
            <div class="empty-order-title">Tu carrito está vacío</div>
            <div class="empty-order-text">
              Agrega platos deliciosos y vuelve cuando estés listo para ordenar.
            </div>
          </div>
          <div class="order-total-row">
            <span>Total</span>
            <strong>S/ {{ totalPedido }}</strong>
          </div>
        </v-card-text>
        <v-divider />
        <v-card-actions class="order-actions">
          <v-btn text @click="dialogPedido = false">Seguir comprando</v-btn>
          <v-spacer />
          <v-btn
            color="secondary"
            dark
            large
            :disabled="!pedido.length"
            @click="confirmarPedido"
          >
            Confirmar Pedido
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <footer class="restaurante-footer">
      <v-container>
        <v-row class="footer-grid" align="center" justify="space-between">
          <v-col cols="12" md="5">
            <div class="footer-title">Restaurante Sabores</div>
            <p>
              Platos peruanos preparados con ingredientes frescos y una atención cálida
              que convierte cada visita en una experiencia memorable.
            </p>
          </v-col>
          <v-col cols="12" md="3">
            <div class="footer-heading">Horario</div>
            <p>Lun - Vie: 10:00 - 22:00<br />Sab - Dom: 11:00 - 23:00</p>
          </v-col>
          <v-col cols="12" md="3">
            <div class="footer-heading">Contacto</div>
            <p>📞 +51 987 654 321<br />📍 Av. Sabores 123, Lima</p>
          </v-col>
        </v-row>
      </v-container>
    </footer>
  </div>
</template>

<script>
export default {
  name: "RestauranteSabores",
  data() {
    return {
      activeTab: 0,
      dialogPedido: false,
      pedido: [],
      menuCategories: [
        { key: "entradas", label: "Entradas" },
        { key: "principales", label: "Platos Principales" },
        { key: "postres", label: "Postres" },
        { key: "bebidas", label: "Bebidas" },
      ],
      menu: {
        entradas: [
          {
            name: "Causa Limeña",
            description: "Causa rellena de pollo y salsa huancaína.",
            price: 25,
            img:
              "https://images.unsplash.com/photo-1525351484163-7529414344d8?ixlib=rb-1.2.1&auto=format&fit=crop&w=1200&q=80",
          },
          {
            name: "Anticuchos",
            description: "Brochetas de corazón marinadas con ají panca.",
            price: 30,
            img:
              "https://images.unsplash.com/photo-1540189549336-e6e99c3679fe?ixlib=rb-1.2.1&auto=format&fit=crop&w=1200&q=80",
          },
          {
            name: "Tiradito Nikkei",
            description: "Filete de pescado con leche de tigre y crocante de katsu.",
            price: 32,
            img: "https://picsum.photos/id/1080/1200/800",
          },
        ],
        principales: [
          {
            name: "Lomo Saltado",
            description: "Saltado de lomito con cebolla, tomate y papas crocantes.",
            price: 45,
            img:
              "https://images.unsplash.com/photo-1551218808-94e220e084d2?ixlib=rb-1.2.1&auto=format&fit=crop&w=1200&q=80",
          },
          {
            name: "Ají de Gallina",
            description: "Clásico cremoso con pollo deshilachado y papa dorada.",
            price: 40,
            img:
              "https://images.unsplash.com/photo-1504674900247-0877df9cc836?ixlib=rb-1.2.1&auto=format&fit=crop&w=1200&q=80",
          },
          {
            name: "Tacu Tacu con Mariscos",
            description: "Arroz y menestra crocante con salsa de mariscos.",
            price: 48,
            img:
              "https://images.unsplash.com/photo-1498654896293-37aacf113fd9?ixlib=rb-1.2.1&auto=format&fit=crop&w=1200&q=80",
          },
        ],
        postres: [
          {
            name: "Suspiro Limeño",
            description: "Dulce tradicional con merengue y crema de manjar.",
            price: 18,
            img:
              "https://images.unsplash.com/photo-1499636136210-6f4ee915583e?ixlib=rb-1.2.1&auto=format&fit=crop&w=1200&q=80",
          },
          {
            name: "Mazamorra Morada",
            description: "Postre de maíz morado con frutas y especias.",
            price: 15,
            img:
              "https://images.unsplash.com/photo-1496417263034-38ec4f0b665a?ixlib=rb-1.2.1&auto=format&fit=crop&w=1200&q=80",
          },
        ],
        bebidas: [
          {
            name: "Chicha Morada",
            description: "Infusión de maíz morado con canela y clavo.",
            price: 12,
            img:
              "https://images.unsplash.com/photo-1509042239860-f550ce710b93?ixlib=rb-1.2.1&auto=format&fit=crop&w=1200&q=80",
          },
          {
            name: "Lima Sour",
            description: "Cóctel refrescante con pisco, limón y clara de huevo.",
            price: 28,
            img:
              "https://images.unsplash.com/photo-1504674900247-0877df9cc836?ixlib=rb-1.2.1&auto=format&fit=crop&w=1200&q=80",
          },
        ],
      },
    };
  },
  computed: {
    totalPedido() {
      return this.pedido.reduce((sum, item) => sum + item.price, 0);
    },
  },
  methods: {
    scrollToMenu() {
      document.getElementById("menu").scrollIntoView({ behavior: "smooth" });
    },
    abrirPedido() {
      this.dialogPedido = true;
    },
    agregarPedido(item) {
      this.pedido.push({ ...item });
      this.abrirPedido();
    },
    eliminarPedido(idx) {
      this.pedido.splice(idx, 1);
    },
    confirmarPedido() {
      alert("Pedido confirmado. En breve nos contactaremos");
      this.pedido = [];
      this.dialogPedido = false;
    },
  },
};
</script>

<style scoped>
.restaurante-sabores {
  background: #fafafa;
}
.back-ribbon {
  position: fixed;
  top: 50%;
  left: 20px;
  transform: translateY(-50%);
  z-index: 2100;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 14px 22px;
  background: linear-gradient(135deg, #d84315 0%, #ff8a65 100%);
  color: white;
  border-radius: 999px;
  box-shadow: 0 22px 36px rgba(0, 0, 0, 0.24);
  cursor: pointer;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 0.06em;
  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}
.back-ribbon v-icon {
  font-size: 1rem;
}
.back-ribbon:hover {
  transform: translateY(-50%) translateX(4px);
  box-shadow: 0 26px 44px rgba(0, 0, 0, 0.28);
  background: linear-gradient(135deg, #ff8a65 0%, #d84315 100%);
}
.restaurante-header {
  position: relative;
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(16px);
  border-bottom: 1px solid rgba(16, 32, 39, 0.08);
}
.brand span {
  display: block;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #d84315;
}
.brand strong {
  font-size: 1.6rem;
  font-weight: 800;
  line-height: 1;
}
.hero-restaurante {
  min-height: 75vh;
  background: linear-gradient(180deg, rgba(8, 19, 40, 0.78), rgba(8, 19, 40, 0.32)),
    url("https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?ixlib=rb-1.2.1&auto=format&fit=crop&w=1600&q=80")
      center/cover no-repeat;
  display: flex;
  align-items: center;
}
.hero-overlay {
  width: 100%;
  padding: 80px 0;
}
.hero-content {
  color: white;
}
.eyebrow {
  display: inline-block;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  margin-bottom: 18px;
  color: #ffcc80;
}
.hero-content h1 {
  font-size: clamp(2.8rem, 5vw, 4.2rem);
  margin-bottom: 18px;
}
.hero-description {
  font-size: 1.05rem;
  max-width: 620px;
  margin: 0 auto 28px;
  color: rgba(255, 255, 255, 0.88);
}
.hero-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
}
.menu-section {
  padding: 80px 0 40px;
}
.section-header {
  max-width: 760px;
  margin: 0 auto 40px;
  text-align: center;
}
.section-label {
  display: inline-block;
  background: rgba(216, 67, 21, 0.08);
  color: #d84315;
  padding: 6px 14px;
  border-radius: 999px;
  font-weight: 700;
  margin-bottom: 14px;
}
.menu-card {
  border-radius: 24px;
  overflow: hidden;
}
.menu-card-title {
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 10px;
}
.menu-card-description {
  color: rgba(16, 32, 39, 0.75);
  margin-bottom: 18px;
}
.menu-card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.menu-image {
  object-fit: cover;
}
.order-item-name {
  font-weight: 700;
}
.order-item-price {
  color: rgba(16, 32, 39, 0.7);
}
.empty-order-card {
  display: grid;
  place-items: center;
  gap: 12px;
  padding: 40px 16px;
  text-align: center;
  background: #faf8f2;
  border-radius: 18px;
  margin-bottom: 18px;
}
.empty-order-title {
  font-weight: 700;
  font-size: 1.05rem;
}
.empty-order-text {
  color: rgba(16, 32, 39, 0.68);
  max-width: 420px;
}
.order-list {
  display: grid;
  gap: 14px;
  margin-bottom: 18px;
}
.order-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 18px;
  background: #ffffff;
  border-radius: 18px;
  border: 1px solid rgba(16, 32, 39, 0.08);
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.04);
}
.order-item-description {
  color: rgba(16, 32, 39, 0.65);
  margin-top: 4px;
}
.order-dialog-accent {
  height: 6px;
  background: linear-gradient(90deg, #ff8a65 0%, #d84315 100%);
  width: 100%;
}
.order-dialog-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 24px 24px 8px;
}
.order-dialog-text {
  display: grid;
  gap: 6px;
}
.order-dialog-label {
  font-size: 1.5rem;
  font-weight: 800;
  letter-spacing: 0.02em;
}
.order-dialog-subtitle {
  font-size: 0.95rem;
  font-weight: 400;
  color: rgba(16, 32, 39, 0.62);
}
.order-card-body {
  padding: 18px 24px 0;
}
.order-list {
  display: grid;
  gap: 14px;
  margin-bottom: 18px;
}
.order-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 20px;
  background: #ffffff;
  border-radius: 18px;
  border: 1px solid rgba(16, 32, 39, 0.08);
  box-shadow: 0 20px 60px rgba(16, 32, 39, 0.05);
}
.order-item-description {
  color: rgba(16, 32, 39, 0.58);
  margin-top: 4px;
}
.order-delete-btn {
  min-width: 0;
  width: 38px;
  height: 38px;
  border: 1px solid rgba(16, 32, 39, 0.1);
  color: rgba(16, 32, 39, 0.65);
}
.order-delete-btn:hover {
  background: rgba(255, 82, 82, 0.08);
}
.empty-order-card {
  display: grid;
  place-items: center;
  gap: 16px;
  padding: 42px 22px;
  text-align: center;
  background: #faf8f2;
  border-radius: 18px;
  margin-bottom: 18px;
}
.empty-order-avatar {
  background: rgba(255, 138, 101, 0.12);
}
.empty-order-title {
  font-weight: 700;
  font-size: 1.05rem;
}
.empty-order-text {
  color: rgba(16, 32, 39, 0.68);
  max-width: 400px;
}
.order-total-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid rgba(16, 32, 39, 0.1);
  font-size: 1.1rem;
  font-weight: 700;
}
.order-actions {
  padding: 20px 24px 24px;
}
.order-dialog {
  border-radius: 32px;
  overflow: hidden;
}
.restaurante-footer {
  background: #102027;
  color: rgba(255, 255, 255, 0.9);
  padding: 48px 0 32px;
}
.footer-grid {
  gap: 24px;
}
.footer-title {
  font-size: 1.5rem;
  font-weight: 800;
  margin-bottom: 14px;
}
.footer-heading {
  margin-bottom: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}
.restaurante-footer p {
  margin: 0;
  color: rgba(255, 255, 255, 0.72);
  line-height: 1.8;
}
@media (max-width: 720px) {
  .footer-grid {
    display: grid;
    gap: 22px;
  }
}
@media (max-width: 960px) {
  .hero-restaurante {
    min-height: 62vh;
  }
  .hero-description {
    margin: 0 auto 20px;
  }
  .menu-card {
    border-radius: 20px;
  }
}
</style>
